import React, { useEffect, useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { AiFillHome } from "react-icons/ai";
import { PiArrowLeftBold } from "react-icons/pi";
import { Link, useParams } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import axios from 'axios';
import { dataDecrypt, dataEncrypt } from '../app/utils/encryption-helper';
import { useSelector } from 'react-redux';
import LoginOtp from './login-screen';
import LOGO from './../assets/images/vyapar_live_main_logo.png';
import { ApisService } from '../app/core/apis.service';
import { AppConfig } from '../app/config';
import { formatDateTimeInIST } from '../components/indiaDateFormate';
import { ProductView } from '../components/product-view';
import { TransactionDetailsUI } from '../components/transaction-details-ui';

export const Packing_Inspections = () => {
  const [packingData, setpackingData] = useState<any>([]);
  const [otpReference, setOtpReference] = useState('');
  const userData = useSelector((state: any) => state.UserDataReducer);
  const [backRouteLink, setBackRouteLink] = useState('');
  const routerParams = useParams();
  const [loading, setLoading] = useState<boolean>(false);

  const created_date: string = ApisService.formatTimestamp(packingData[0]?.invoice_details?.invoice_date);

  useEffect(() => {
    loadPacking();
  }, []);



  async function loadPacking(): Promise<void> {
    setLoading(true);
    try {
      const res = await ApisService.getTransactionData('finInvoiceById', routerParams.id || '');
      setLoading(false);
      const data: any = res.data.data;
      const transactionData = JSON.parse(dataDecrypt(data));
      setpackingData([...transactionData]);
      if (transactionData[0]?.transactionId) {
        setBackRouteLink(dataEncrypt(JSON.stringify({ id: transactionData[0].transactionId })));
        const preparedReference = dataEncrypt(JSON.stringify({ invoice: transactionData[0].id, id: transactionData[0].transactionId, type: 'packing' }));
        setOtpReference(preparedReference);
      }
    } catch (error) {
      setLoading(false);
    }
  }
  return (

    <div>
      {(!userData || !userData?.otp) && <LoginOtp reference={otpReference} />}
      {userData?.otp && <>
        <div className='d-flex justify-content-between p-3 sticky-top align-items' style={{ backgroundColor: "#274472", color: "white", zIndex: "1" }}>
          <Link to={`/order/${backRouteLink}`}><span ><PiArrowLeftBold size={22} className='text-white' /></span></Link>
          <span style={{ lineHeight: "0" }} className='text-center'><h4>Packing & Inspection</h4><div>{('currency_symbol' in (packingData[0]?.buyer || {})) ? (
            <>{packingData[0]?.buyer?.name}</>
          ) : ('currency_symbol' in (packingData[0]?.seller || {})) ? (
            <>{packingData[0]?.seller?.name}</>
          ) : (
            <p></p>
          )}</div></span>
          <img src={LOGO} alt="" height={60} />
        </div>
        <br />

        {!loading ? <div className='container-fluid'>
          {packingData[0]?.invoice_details?.package_details ? <div>
            <div style={{ backgroundColor: "white", borderRadius: "3px" }}>
              <TransactionDetailsUI data={[{ header: 'Seller', value: packingData[0]?.seller?.name }, { header: 'Txn Date', value: formatDateTimeInIST(packingData[0]?.invoice_details?.invoice_date) }, { header: 'Txn Id', value: packingData[0]?._id }]} />
            </div><br />

            <div className='row mb-2 align-items'>
              <div className='col-6'><b>Invoice No: {packingData[0]?.invoice_number}</b></div>
              <div className='col-6 text-end'><a target='_blank' href={`${AppConfig.BASE_URL}/pdfs/${packingData[0]?.transactionId}/invoice-pdf/${packingData[0]?.invoice_details?.bill_no}`}>
                view invoice
              </a></div>
            </div>
            <div className='card border-0 rounded-4 box-shadow mb-3'>
              <div className='card-body'>
                {packingData[0]?.invoice_details?.package_details?.status === "skipped"?<h4 className='text-center mb-0'>The packing step was skipped for this Invoice</h4>:<div>
                  <h5 className='primary-color mt-2'>Packing Details</h5>
                  <table className="table table-hover">
                    <tbody>
                      <tr>
                        <th scope="row">No.of.Boxes</th>
                        <td>{packingData[0]?.invoice_details?.package_details?.no_packages}</td>
                      </tr>
                      <tr>
                        <th scope="row">Weight</th>
                        <td>{packingData[0]?.invoice_details?.package_details?.unit_of_mesurments?.weight}</td>
                      </tr>
                      <tr>
                        <th scope="row">Height</th>
                        <td>{packingData[0]?.invoice_details?.package_details?.unit_of_mesurments?.height}</td>
                      </tr>
                      <tr>
                        <th scope="row">Width</th>
                        <td>{packingData[0]?.invoice_details?.package_details?.unit_of_mesurments?.width}</td>
                      </tr>
                      <tr>
                        <th scope="row">Depth</th>
                        <td>{packingData[0]?.invoice_details?.package_details?.unit_of_mesurments?.depth}</td>
                      </tr>
                      <tr>
                        <th scope="row">Volume</th>
                        <td>{packingData[0]?.invoice_details?.package_details?.unit_of_mesurments?.volume}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>}
              </div>
            </div>
            {packingData[0]?.invoice_details?.package_details?.packing_image &&
              <div className="row  align-items-center">
                <h5 className='primary-color mb-2 '>Packing image</h5>
                <div className="col-md-4"></div>
                <div className="col-md-4 text-center">
                  <img
                    src={`${AppConfig?.IMAGE_PATH}${packingData[0]?.invoice_details?.package_details?.packing_image}`}
                    alt="Packing"
                    style={{ cursor: 'pointer', height: '200px', objectFit: 'scale-down' }}
                    onClick={() => window.open(`${AppConfig?.IMAGE_PATH}${packingData[0]?.invoice_details?.package_details?.packing_image}`, '_blank')}
                  />
                </div>
                <div className="col-md-4"></div>
              </div>
            }
          </div> : <h4 className='text-center mb-3 fw-bold'>Packing Not Completed</h4>}
          <div className='text-center my-2 '><Link to={`/order/${backRouteLink}`}><button className='px-4 py-2 rounded'>Track All Steps of This Transaction</button></Link></div>
        </div> : <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
          <div className="spinner-border text-secondary" role="status"></div>
        </div>}
      </>}
    </div>
  )
}